'use client';

import React from 'react';
import { LoadScript } from '@react-google-maps/api';

interface Props {
  children: any;
}

const libraries: ("places")[] = ['places'];

export const GoogleMapsProvider: React.FC<Props> = ({ children }) => {
  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  
  if (!apiKey) {
    console.warn('Google Maps API key not found');
    return <>{children}</>;
  }

  return (
    <LoadScript
      googleMapsApiKey={apiKey}
      libraries={libraries}
      loadingElement={<div></div>}
    >
      {children}
    </LoadScript>
  );
};